module.exports = __webpack_public_path__ + "abd5621cd0cbe8938daaef45e56ac35c.gif";